import * as React from "react";
import { Typography, Button } from "antd";
import MultiSelect from "../app/MultiSelect";
import SelectInput from "../app/SelectInput";
import { IReportingPeriodItem } from "../../../model/report/ReportingPeriodItem";
import { IReport6Applicant } from "../../../model/report/Report6Applicant";

const Report6ParamsBox = ({
  translate,
  applicants,
  onApplicantsChange,
  selectedApplicantIds,
  selectedReportingPeriod,
  onChangeReportingPeriod,
  reportingPeriodList,
  getPDFReport,
  loading,
  onApplicantSearch
}: {
  translate: any;
  applicants: IReport6Applicant[];
  onApplicantsChange: (values: any[]) => void;
  selectedApplicantIds?: string[];
  selectedReportingPeriod?: IReportingPeriodItem;
  onChangeReportingPeriod(reportingPeriodId: number): void;
  reportingPeriodList: IReportingPeriodItem[];
  getPDFReport(): void;
  loading?: boolean;
  onApplicantSearch: (fullName: string) => void;
}) => {
  const isSubmitButtonDisabled = () => {
    if (selectedApplicantIds && selectedApplicantIds.length > 0) {
      return false;
    }
    return true;
  };

  return (
    <div className={"report-sidebar"}>
      <div className={"report-param-title "}>
        <Typography.Title style={{ fontSize: 14 }}>
          {translate("report6.reporting_period")}
        </Typography.Title>
        <SelectInput
          value={selectedReportingPeriod?.id.toString()}
          placeholder={translate("report3.choose_reporting_period")}
          selectOptions={reportingPeriodList}
          selectOptionKey={"id"}
          selectOptionValue={"name"}
          style={{ width: "100%" }}
          onChange={(e) => onChangeReportingPeriod(parseInt(e, 10))}
          defaultActiveFirstOption={false}
          allowClear={true}
          showSearch={true}
          notFoundContent={translate("search.no_data")}
        />
        <div style={{ marginTop: 20 }}>
          <Typography.Title style={{ fontSize: 14 }}>
            {translate("report6.applicants")}
          </Typography.Title>
          <MultiSelect
            mode={"multiple"}
            options={applicants}
            selectOptionKey={"id"}
            selectOptionValue={"fullName"}
            onChange={onApplicantsChange}
            placeholder={translate("report6.applicants_placeholder")}
            value={selectedApplicantIds}
            notFoundContent={translate("search.no_data")}
            onSearch={(value) => onApplicantSearch(value)}
            style={{ width: "100%" }}
          />
        </div>
      </div>

      <Button
        type="primary"
        onClick={getPDFReport}
        loading={loading || false}
        disabled={isSubmitButtonDisabled()}
        style={{ width: "100%" }}
        className={"report-btn"}
      >
        {translate("reports.show")}
      </Button>
    </div>
  );
};

export default Report6ParamsBox;
